import { useCallback, useState } from 'preact/hooks';

export function useRerender() {
    const [, setState] = useState({});

    const rerender = useCallback(() => {
        setState({});
    }, []);

    return rerender;
}
